// Ошибка API поверх huma problem+json. Несёт HTTP-статус, стабильный доменный
// code (COMPANY_NOT_FOUND, SLUG_TAKEN, VERSION_CONFLICT, FORBIDDEN, …) и detail —
// по ним UI разводит 403-экран, конфликт версий, тосты.

interface ProblemBody {
  status?: number
  title?: string
  detail?: string
  code?: string
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string | undefined
  readonly detail: string | undefined

  constructor(status: number, message: string, code?: string, detail?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.detail = detail
  }

  static from(status: number, body: unknown): ApiError {
    const problem = (body ?? {}) as ProblemBody
    const message = problem.detail || problem.title || `HTTP ${status}`
    return new ApiError(status, message, problem.code, problem.detail)
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }

  get isForbidden(): boolean {
    return this.status === 403
  }

  get isConflict(): boolean {
    return this.status === 409
  }
}
